import { createContext, useContext } from "react";

export const SessionContext = createContext(null);

export const useSession = () => {
  const session = useContext(SessionContext);
  if (!session && session !== null) {
    throw new Error("useSession must be used within a SessionContext.Provider");
  }
  return session;
};
